import { createSpinnerMaterial } from '@subaio/components'

const MaterialSpinner = createSpinnerMaterial(({ theme }) => ({
	color: theme.color.action,
	size: 64,
}))

export const Spinner = () => <MaterialSpinner />
